export function cameraNameForUrl(cameraName: string): string {
  return cameraName.replace(/ /g, "-").toLowerCase();
}
